import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
    standalone: false,
    name: 'convertToNumber'
})

export class ConvertToNumberPipe implements PipeTransform {
    transform(number: any): number {
        if (number) {
            return Number(number);
        } else {
            return 0;
        }
    }
}
